import {
  useState
} from 'react';

import {
  Button,
  DialogTitle,
} from '@headlessui/react';

import './App.scss';

import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import Fancybox from './common/Fancybox';

const instructions = [
  {
    url: '/instructions/1-instructions-Lacoste.jpg',
    description: 'วิธีการแก้ไขอีเมล ในข้อมูลบัญชีสมาชิก'
  },
  {
    url: '/instructions/2-instructions-Lacoste.jpg',
    description: 'ตรวจสอบคะแนน Le Club Lacoste Point บน LINE Official : @lacoste_thailand'
  },
  {
    url: '/instructions/3-instructions-Lacoste.jpg',
    description: 'หากอีเมลที่ลงทะเบียนสมัครสมาชิก Le Club Lacoste ไม่ตรงกับที่ลงแอปพลิเคชัน LINE'
  },
  {
    url: '/instructions/4-instructions-Lacoste.jpg',
    description: 'แก้ไขดังนี้ 1. ตรวจสอบอีเมลที่ลงทะเบียนไว้กับแอปพลิเคชั่น LINE 2. คลิกลิงค์เพื่อแก้ไขอีเมลสมาชิก Le Club Lacoste ให้ตรงกับแอปพลิเคชัน LINE'
  },
  {
    url: '/instructions/5-instructions-Lacoste.jpg',
    description: 'เข้าลิงค์ https://www.lacoste.co.th/th/login'
  },
  {
    url: '/instructions/6-instructions-Lacoste.jpg',
    description: 'เข้าสู่ระบบ เลือก "ฉันเป็นสมาชิกอยู่แล้ว"'
  },
  {
    url: '/instructions/7-instructions-Lacoste.jpg',
    description: '1. ระบุ "หมายเลขโทรศัพท์" หรือ "อีเมล" สมาชิก 2. ใส่ "รหัสผ่าน" 3. คลิกปุ่ม "เข้าสู่ระบบ"'
  },
  {
    url: '/instructions/8-instructions-Lacoste.jpg',
    description: 'คลิกปุ่ม "แก้ไขข้อมูลบัญชีท่านสมาชิก"'
  },
  {
    url: '/instructions/9-instructions-Lacoste.jpg',
    description: 'คลิก "โปรไฟล์ของฉัน"'
  },
  {
    url: '/instructions/10-instructions-Lacoste.jpg',
    description: 'แก้ไข "อีเมล" ตามที่ลงทะเบียนไว้กับแอปพลิเคชัน LINE'
  },
  {
    url: '/instructions/11-instructions-Lacoste.jpg',
    description: 'คลิก "บันทึก" แก้ไขอีเมลเรียบร้อย'
  },
  {
    url: '/instructions/12-instructions-Lacoste.jpg',
    description: 'กลับเข้าสู่ LINE Official : @lacoste_thailand, กดเมนู "Le Club Lacoste point" Created by Data Discovery'
  },
  {
    url: '/instructions/13-instructions-Lacoste.jpg',
    description: 'ข้อมูลสมาชิก เชื่อมต่อเรียบร้อยค่ะ'
  },
  {
    url: '/instructions/14-instructions-Lacoste.jpg',
    description: 'ตรวจสอบคะแนน เข้าเมนู "PROFILE"'
  },
  {
    url: '/instructions/15-instructions-Lacoste.jpg',
    description: 'ตรวจสอบประวัติการสั่งซื้อ เข้าเมนู "HISTORY"'
  },
  {
    url: '/instructions/16-instructions-Lacoste.jpg',
    description: 'LACOSTE ขอขอบคุณที่ให้ความสนใจในการเป็นสมาชิก Le Club Lacoste'
  },
]

function NoAccess(
  { email }: { email: String | null }
) {

  const [notFoundLanguage, setNotFoundLanguage] = useState<String>('th');

  return (
    <div className="z-10 w-screen overflow-y-auto">
      <div className="flex min-h-dvh items-center justify-center bg-white/100">
        <div
          className="w-full px-12 py-6 duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0 overflow-y-auto relative"
        >
          <Button
            className="absolute right-0 top-0 gap-2 py-1.5 px-3 text-sm/6 font-semibold text-green-900 z-10 data-[hover]:bg-green-700"
            onClick={() => setNotFoundLanguage(notFoundLanguage === 'th' ? 'en' : 'th')}
          >
            {notFoundLanguage === 'th' ? 'EN' : 'TH'}
          </Button>
          <h3 className="text-base/7 font-medium text-orange text-center items-center">
            <ExclamationTriangleIcon className="h-24 w-24 text-orange-700 mx-auto" aria-hidden="true" />
          </h3>
          {
            notFoundLanguage === 'th' ?
              <p className="mt-2 text-sm/6 text-black/100 text-center">
                ขออภัย<br />
                ระบบตรวจสอบไม่พบอีเมลของท่าน<br />ทั้งนี้อาจเกิดจากอีเมลที่ท่านระบุในระบบสมาชิกไม่ตรงกับอีเมลที่ท่านลงทะเบียนไว้กับแอปพลิเคชัน LINE
                <br /><br />
                อีเมลที่ท่านลงทะเบียนไว้กับแอปพลิเคชัน LINE
                <br />
                <span className='prompt-semibold'>{email}</span>
                <br /><br />
                กรุณาแก้ไขข้อมูลอีเมลของบัญชีสมาชิกให้เป็นข้อมูลเดียวกันกับอีเมลของแอปพลิเคชัน LINE ได้ทาง
              </p>
              :
              <p className="mt-2 text-sm/6 text-black/100 text-center">
                We're sorry, but our system could not find your email. This may be because the email you provided in your membership account does not match the email registered with the LINE application.
                <br /><br />
                The email registered with your
                LINE application is
                <br />
                <strong className='prompt-semibold'>{email}</strong>
                <br /><br />
                Please update the email in your membership account to match the one used for the LINE application at the following link:
              </p>
          }
          <div className="mt-4 grid gap-2 items-center">
            <a href="https://www.lacoste.co.th/login" rel="noreferrer" className="w-full">
              <Button
                className="w-full items-center gap-2 bg-green-800 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-black/10 focus:outline-none data-[hover]:bg-green-700 data-[focus]:outline-1 data-[focus]:outline-black data-[open]:bg-green-800"
              >
                https://www.lacoste.co.th
              </Button>
            </a>
          </div>
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
              compact: true
            }}
          >
            <div className="mt-4 grid gap-2 items-center text-center justify-center">
              {
                instructions.map(
                  (instruction, index) => <a key={index} 
                  data-fancybox="gallery" 
                  href={instruction.url} 
                  title={instruction.description}
                  >
                    <img className='w-full h-auto' src={instruction.url} alt={instruction.description} />
                  </a>
                )
              }
            </div>
          </Fancybox>
        </div>
      </div>
    </div>
  );
}

export default NoAccess;